let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('a0IFD') + "pdf.worker.entry.d2650dec.js";module.exports = workerURL(url, bundleURL.getOrigin(url), false);